var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrgSmall24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.515 7.608A4.52 4.52 0 007 12.123v2.723c0 .116.048.232.136.31a.418.418 0 00.31.135H8.88c.116 0 .213.078.223.194l.62 6.23a.44.44 0 00.436.397h2.722a.44.44 0 00.436-.397l.62-6.23c0-.116.107-.203.223-.194h1.434a.457.457 0 00.446-.445v-2.723a4.52 4.52 0 00-4.515-4.515h-.01zm3.081-3.662A2.946 2.946 0 0011.67 1C10.052.99 8.734 2.308 8.725 3.926a2.946 2.946 0 002.926 2.946 2.938 2.938 0 002.935-2.926h.01z"
  })));
}
export default SvgIconOrgSmall24;